import { useTranslate } from "../providers/LocalizationProvider";

export const T = (props) => useTranslate(props.children, props) || null;